<template>
    <v-select v-model="value"
              :dense="dense"
              :disabled="disabled"
              :items="items"
              item-text="nombre"
              item-value="id"
              label="Cliente"
              @change="change"
              @focus="focus"
              :menu-props="{ auto: true, botton: true, offsetY: true }">
    </v-select>
</template>

<script>
    import { mapState, mapActions } from 'vuex';

    export default {
        name: 'selectCliente',
        props: {
            disabled: {
                required: false
            },
            dense: {
                required: false
            },
            value: {
                type: Number
            },
            texto: {
                type: String
            }
        },
        //        ['', 'dis', 'texto', 'disabled', 'dense'],
        data: function () {
            return {
                pvalue: 0,
                ptexto: ''
            };
        },
        computed: {
            ...mapState('cliente', ['items'])
        },
        methods: {
            ...mapActions('cliente', ['getAll']),

            change(id) {
                this.$emit('input', id);

                var r = this.items.find(function (item) {
                    if (item.id === id) {
                        return item.nombre;
                    }
                });
                this.$emit('texto', r.nombre);
                this.$emit('change', r);
            },
            focus() {
                this.pvalue = this.value;
                this.ptexto = this.texto;
            }
        },
        mounted() {
            this.getAll();
        }
    };
</script>
